import axios from 'axios';
import {
	utilityService
} from '@/services/utilityService.js';
import { dateService } from "@/services/date.service.js";


export const taskService = {
	getTasksGeneral,
	// Returns JSON formatted tasks based on: study, status, start & end dates

	// Returns GEO_JSON formatted ... based on: study, spid
	getTaskAllUpdates,

	// Returns GEO_JSON formatted sk object specified byy the task id
	getTaskForId,

	// ask to change backend to put parameter into body
	updateTaskAnalysis,

	// Returns task counts for a study
	getTaskCounts,

	// Returns task percentages based on: study, start & end dates
	getTaskPercentages,

	// Returns JSON format task objects for a particular: study, staffId, startDate and enddate
	getTaskForSelectedStaffId,

	// Returns GEO_JSON format a particular task: study and task id
	getTaskForDisplayPopUp
};

// #region task

// Returns JSON formatted tasks based on: study, status, start & end dates
function getTasksGeneral (criteria) {
	var fields = ''
	console.log('getTasksGeneral criteria: ', criteria)
	// if (criteria.status !== ['ALL'] && criteria.status !== 'ALL') {
		fields += '&status=' + criteria.status
	// }
	if (criteria.staff !== undefined && criteria.staff !== 'ALLSTAFF') {
		fields += '&staffId=' + criteria.staff
	}
	if (criteria.spid !== 'ALL' && criteria.spid !== '') {
		fields += '&spid=' + criteria.spid
	}
	console.log('cht fields: ', fields)
	var inclusions = 'alternateLocation, dateEnd, staffId, taskStatus, duid, spid, region, psu, studyDispCode, studyDispCodeLabel, taskLabel, taskStatusBasis, geoMatchType, clusterDuration, clusterDistance, taskUUID, nameFirst, nameLast, point'
	return axios.get(utilityService.buildFullyQualifiedUrl(`task/find?format=json&studyCode=${criteria.study}&remote=false&dateStart=${criteria.startdate}&dateEnd=${criteria.enddate}&currentStatus=true&timeLocal=true${fields}&includes=${inclusions}`),
	// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// Returns GEO_JSON formatted ... based on: study, spid
function getTaskAllUpdates (criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`task/updates/?format=geojson&studyCode=${criteria.study}&uuid=${criteria.id}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// Returns GEO_JSON formatted sk object specified byy the task id
function getTaskForId (criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`task/uuid/?format=geojson&studyCode=${criteria.study}&uuid=${criteria.id}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// ask to change back end to move data into body of put instead of url
function updateTaskAnalysis (study, taskId, status, comment, basis, username) {
	// Make sure we encode any special chars. This will be unencoded/decoded by API endpoint
	const encodedComment = utilityService.encodeQueryStringParameter(comment);
	return axios.put(utilityService.buildFullyQualifiedUrl(`task/update/status?studyCode=${study}&uuid=${taskId}&status=${status}&basis=${basis}&commentText=${encodedComment}&commentAuthor=${username}`),
		// Second parameter is the data/body
		{},
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// Returns task counts for a study
function getTaskCounts (criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`task/agg/status?studyCode=${criteria.study}&start=${criteria.startdate}&end=${criteria.enddate}`),


		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// Returns task percentages based on: study, start & end dates
function getTaskPercentages (criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`task/percentages/date/?studyCode=${criteria.study}&start=${criteria.startdate}&end=${criteria.enddate}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// Returns JSON format task objects for a particular: study, staffId, startdate and enddate
function getTaskForSelectedStaffId (criteria) {
	console.log("cht getTaskforselctedstaffid criteria: ", criteria)
	return axios.get(utilityService.buildFullyQualifiedUrl(`task/find?format=JSON&staffId=${criteria.staffId}&studyCode=${criteria.study}&dateStart=${criteria.startdate}&dateEnd=${criteria.enddate}&timeLocal=true&includes=point,duid,spid,taskLabel,taskStatus,updates,taskUUID,staffId,clusterDuration,dateEnd,pointCompletedType,taskStatusBasis`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// Returns GEO_JSON format a particular task: study and task id
function getTaskForDisplayPopUp (criteria, study) {
	console.log("cht getTaskForDisplayPopUp criteria: ", criteria)
	console.log("cht getTaskForDisplayPopUp study: ", study)

	return axios.get(utilityService.buildFullyQualifiedUrl(`task?format=GEO_JSON&studyCode=${study}&uuid=${criteria.taskUUID}`),

		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// #endregion task
